<template>
  <div class="image-card" :style="wh">
    <a class="image-card-mask" :style="mask" @click="handleClick">
      <span class="image-card-title">{{this.media.filename}}</span>
    </a>
  </div>
</template>
<script>
export default {
  name: 'ImageCard',
  props: {
    media: {
      type: Object,
      default: null
    }
  },
  components: {
  },

  data () {
    // console.log('media -->', this.media)
    this.realHeight = 220
    this.realWidth = this.media.width * this.realHeight / this.media.height
    let st = `height: ${this.realHeight}px; width: ${this.realWidth}px; max-width: 700px; background: url("${this.media.thumbnail}") no-repeat;`
    let stm = `height: ${this.realHeight}px; width: ${this.realWidth}px;`
    return {
      wh: st,
      mask: stm,
      realHeight: 220,
      realWidth: 0,
      show: false,
      showDetail: false
    }
  },
  methods: {
    handleClick (event) {
      this.$router.push('/explorer/detail/' + this.media.id)
    }
  }
}
</script>
<style scoped>
.image-card {
  display: inline-flex;
  background-color: gray;
  margin: 0 5px 5px 0 !important;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}
.image-card-mask {
  display: block;
  width: 100%;
  height: 100%;
}
.image-card-mask:hover {
  background: linear-gradient(
    rgba(0,0,0,0.7),
    rgba(0,0,0,0.7) 5%,
    rgba(0,0,0,0) 80%
  );
}
.image-card-title {
  display: inline-flex;
  color: #fff;
  margin: 0 0 2px 6px;
  flex-direction: column-reverse;
  font-weight: bold;
}

</style>
